import Stack from '@mui/material/Stack';
import React, { PropsWithChildren } from 'react';
import { applyFilters, Filters } from '../../../core';
import { Device } from '../../../plugins/device/src/type';
import Section from '../Section/Section';
import css from './service-form.module.scss';
import Cover from '../Cover/Cover';
import Typography from '../Typography/Typography';
import Spacer from '../Spacer/Spacer';

type Props = PropsWithChildren<Pick<Device, 'attributes'>> & {
  image?: string;
  title?: string;
};

const Attributes = ({ attributes }: Pick<Props, 'attributes'>) => (
  <ul className={css.attributes}>
    {Object.entries(attributes).map(([key, value]) => (
      <li className={css.item} key={key}>
        <span className={css.label}>{key}</span>
        <span className={css.value}>
          {['string', 'number'].includes(typeof value) ? value : ''}
          {typeof value === 'object' && value.hasOwnProperty('label')
            ? value.label
            : ''}
        </span>
      </li>
    ))}
  </ul>
);

const DeviceServiceForm = ({ attributes, image, children, title }: Props) => {
  const deviceAttributes = applyFilters(
    Filters.reports.serviceRequestDeviceAttributes,
    attributes || {},
  );

  return (
    <Stack direction="column">
      <Stack direction="row">
        <Section>
          {title && (
            <Stack direction="column">
              <Typography variant="h1">{title}</Typography>
              <Spacer size={2} />
            </Stack>
          )}
          <Attributes attributes={deviceAttributes} />
        </Section>
        {image && (
          <Section>
            <Cover url={image} />
          </Section>
        )}
      </Stack>
      {children}
    </Stack>
  );
};

export default DeviceServiceForm;
